import { Link } from "react-router";
import { talkAssets } from "../lib/assets";
import { talkBrand } from "../lib/brand";
import { ui } from "../lib/ui";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className={`brand${compact ? " brand--compact" : ""}`} to="/" aria-label={ui(`${talkBrand.productName} home`, `На главную ${talkBrand.productName}`)}>
      <span className={`brand__mark${talkBrand.neutralAvatars ? " brand__mark--neutral" : ""}`}>
        <img src={talkAssets.brandMark} alt="" />
      </span>
      <span className="brand__name">{talkBrand.id === "chess" ? <strong>{talkBrand.productName}</strong> : <><strong>{talkBrand.organizationName}</strong> Talk</>}</span>
    </Link>
  );
}
